import { Injectable } from '@angular/core';
import { QueryConstraint, where } from '@angular/fire/firestore';
import { Observable, map } from 'rxjs';
import { Event, EventFirebase } from '../models/event.model';
import { DbService } from 'src/app/core/services/db.service';
import { toDate } from 'src/app/shared/utils/firestore-timestamp-utils';
import { normalizeEventEndDate } from '../../utils/event-date-range';

@Injectable({
  providedIn: 'root',
})
export class EventsService {
  constructor(private db: DbService) {}

  getPublishedEvents(): Observable<Event[]> {
    const constraints: QueryConstraint[] = [where('isPublished', '==', true)];

    return this.db
      .collection$<EventFirebase & { id: string }>('events', constraints)
      .pipe(
        map((events) => events.map((event) => this.transformFromFirebase(event)))
      );
  }

  private transformFromFirebase(event: EventFirebase & { id: string }): Event {
    return {
      ...event,
      endDate: normalizeEventEndDate(event.date, event.endDate),
      createdAt: toDate(event.createdAt),
      updatedAt: toDate(event.updatedAt),
    };
  }
}
